import type { EdgeId } from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import type { GraphState } from 'components/Graph/GraphState';
import { makeMemoizedGetNestedObjectKeys } from 'utils/memoize/makeMemoizedGetObjectKeys';
import { createScopedSelector } from 'utils/react/scopedSelector';

export const selectEdgeIds: (s: GraphState) => EdgeId[] = createScopedSelector(
  () => makeMemoizedGetNestedObjectKeys(prop('graph', 'edges')),
);
